module.exports = __webpack_public_path__ + "static/media/info.5cb1b113.svg";